import LegalLayout from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" path="/legal/privacy" description="How Queen Cleopatra handles bookings, enquiries, newsletter data and confidentiality. No card data is stored on this site; all media sales are handled by external platforms.">
      <p>Your privacy is fundamental to this practice. This policy explains what is collected, why, and how it is protected. The site is GDPR-friendly.</p>
      <h3 className="font-serif text-2xl text-cream mt-8">What we collect</h3>
      <p>Booking and contact information you provide (name, email, optional phone, session preferences). No payment card data is collected or stored on this site.</p>
      <h3 className="font-serif text-2xl text-cream mt-8">How we use it</h3>
      <p>To respond to inquiries, confirm bookings, and meet legal obligations. We do not sell your data.</p>
      <h3 className="font-serif text-2xl text-cream mt-8">Third parties</h3>
      <p>Media sales by external platforms (Unlockt.me, Clips4sale, iWantClips). Each handles your information under their own privacy policies.</p>
      <h3 className="font-serif text-2xl text-cream mt-8">Your rights</h3>
      <p>You may request access, correction, or deletion of your personal information at any time by writing to us via the Contact page.</p>
    </LegalLayout>
  );
}
